import CreateReportOrWorkspaceButton from './CreateReportOrWorkspaceButton';
import {MAXIMUM_NUMBER_OF_WORKSPACES} from '../../const';
import usePayment from '../../hooks/providers/usePayment';
import useProfile from '../../hooks/providers/useProfile';
import useWorkspaces from '../../hooks/providers/useWorkspaces';

const CreateWorkspaceButton = () => {
  const {hasTrialEnded, hasMembership, isPartner, isAdmin} = usePayment();
  const {openCreateWorkspaceModal, workspaces, workspacesFetching, isWorkspaceCreationInProgress} = useWorkspaces();
  const {isPartnerPolicy} = useProfile();

  const maximumNumberOfWorkspacesReached = workspaces.length >= MAXIMUM_NUMBER_OF_WORKSPACES;
  const handleButtonClick = maximumNumberOfWorkspacesReached && !isAdmin ? null : openCreateWorkspaceModal;
  const userNeedsToTakSubscription = !isPartner && !isPartnerPolicy && hasTrialEnded && !hasMembership;

  const getTooltipMessage = () => {
    if (isAdmin) return '';

    if (maximumNumberOfWorkspacesReached) {
      return "Vous avez atteint la limite d'espaces personnels que vous pouvez créer.";
    }

    // if (userNeedsToTakeSubscription) {
    //   return "Votre période d'essai est terminée. Sélectionnez un abonnement pour ajouter de nouveaux espaces de travail";
    // }

    if (workspacesFetching) {
      return 'Chargement de vos espaces en cours. Veuillez patienter.';
    }

    if (isWorkspaceCreationInProgress) {
      return 'Un espace est en cours de création. Veuillez patienter.';
    }

    return '';
  };

  const tooltip = getTooltipMessage();
  return (
    <CreateReportOrWorkspaceButton
      disabled={!isAdmin && (maximumNumberOfWorkspacesReached || isWorkspaceCreationInProgress || workspacesFetching)}
      maxLimitReached={!isAdmin && maximumNumberOfWorkspacesReached}
      onClick={handleButtonClick}
      tooltipTitle={tooltip}
      label="Ajouter un espace"
      size="medium"
    />
  );
};

export default CreateWorkspaceButton;
